<template>
  <div class="w-100">
    <v-chart
      v-if="genders.length > 0"
      chart-type="doughnut"
      :data-sets="dataSets"
      :labels="labels"
      size="sm"
      :download-enabled="false"
      :show-legend="false"
    />
  </div>
</template>

<script>
import Chart from '@/organisation/components/dashboard/Chart.vue';

const GENDERS = {
  m: 'word.male',
  f: 'word.female',
  o: 'word.other',
  u: 'word.unknown',
};

const COLORS = {
  m: '#7396be',
  f: '#c99c9e',
  o: '#81be73',
  u: '#a2a2a2',
};

export default {
  name: 'GenderDoughnutChart',
  components: {
    'v-chart': Chart,
  },
  props: {
    genders: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      GENDERS,
      COLORS,
      genderCounts: {},
    };
  },
  computed: {
    labels() {
      return Object.keys(this.genderCounts).map((gender) => (this.$t(GENDERS[gender])));
    },
    dataSets() {
      return [{
        data: Object.values(this.genderCounts),
        backgroundColor: Object.keys(this.genderCounts).map((gender) => (COLORS[gender])),
        hoverOffset: 4,
      }];
    },
  },
  methods: {
    groupGenders() {
      const genderCounts = {};
      let genderAbr = null;
      this.genders.forEach((gender) => {
        genderAbr = gender || 'o';
        if (genderAbr in genderCounts) {
          genderCounts[genderAbr] += 1;
        } else {
          genderCounts[genderAbr] = 1;
        }
      });
      Object.keys(GENDERS).forEach((gender) => {
        if (genderCounts[gender]) {
          this.genderCounts[gender] = genderCounts[gender];
        }
      });
    },
  },
  created() {
    this.groupGenders();
  },
};
</script>
